<div class="agpr-formField agpr-seriesPickerCompareField">
    <ng-template #panelHeader *ngIf="showContent && isNewReport">
        <div class="agpr-panelHeader-selectedCharts">
            {{ 'Reports.quickReport.chart' | localize }}
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-infoIconStyle"
                [agprTooltip]="selectedCharts | listTooltip"
                [escape]="false"
            ></span>
        </div>
    </ng-template>
    <div class="agpr-seriesPickerCompareField-message">
        <agpr-message
            *ngIf="!showContent"
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Reports.quickReport.chart.comparison.error' | localize }}
        </agpr-message>
    </div>
    <div
        class="agpr-seriesPickerCompareFieldContainer"
        [style.display]="showContent ? 'block' : 'none'"
        role="group"
        [attr.aria-labelledby]="field.headingId"
    >
        <div class="agpr-seriesPickerCompareField-compareOptionDropdownContainer">
            <agpr-dropdown
                [id]="id + '.compareOptionDropdown'"
                [options]="compareOptions"
                [(ngModel)]="selectedCompareOption"
                (ngModelChange)="selectCompareOption()"
                label="Reports.seriesCompareDropdownLabel"
            ></agpr-dropdown>
        </div>
        <div *ngIf="selectedCompareOption.value === SeriesCompareOptionsEnum.individual; else compare">
            <agpr-series-picker-field
                [id]="id"
                [block]="block"
                [field]="field"
                [(value)]="seriesList"
                [showLabel]="false"
                [showContent]="true"
                [showColorSwatch]="field?.showColorSwatch"
                [ariaDescribedBy]="ariaDescribedBy"
                (changes)="changes.emit($event)"
                [showHiddenOption]="showHiddenOption"
            ></agpr-series-picker-field>
        </div>
        <ng-template #compare>
            <div class="agpr-seriesPickerCompareField-inputGroupContainer">
                <div class="agpr-seriesPickerCompareField-buttonContainer">
                    <div class="agpr-seriesPickerCompareField-inputGroup-title">
                        <span>
                            {{ 'Reports.series.source.label' | localize }}
                        </span>
                    </div>
                    <agpr-button
                        [id]="id + '.viewSeriesSource'"
                        icon="fa-regular fa-duotone fa-eye"
                        (click)="goToParentSource($event)"
                        tooltip="Reports.series.source.viewSource"
                        class="agpr-seriesPickerCompareField-buttonContainer-button"
                    ></agpr-button>
                </div>
                <div class="agpr-seriesPickerCompareField-inputGroup">
                    <agpr-autocomplete
                        [id]="id + '.autocomplete'"
                        class="agpr-seriesPickerCompareField-autocomplete"
                        [inputGroupLeft]="true"
                        [suggestions]="parentOptions$"
                        labelField="label"
                        [placeholder]="parentPlaceholders[selectedCompareOption?.value] | localize"
                        [dropdown]="true"
                        [(ngModel)]="selectedParentOption"
                        (itemSelected)="selectParentOption($event)"
                        [clearOnBlur]="false"
                        (clear)="selectParentOption(null)"
                        [ariaLabel]="'Reports.series.source.label'"
                    ></agpr-autocomplete>
                    <agpr-filter-dropdown
                        id="seriesPickerCompareField"
                        class="agpr-seriesPickerCompareField-filterDropdown"
                        [inputGroupRight]="true"
                    ></agpr-filter-dropdown>
                </div>
                <div
                    *ngIf="hasActiveFilters"
                    class="agpr-seriesPickerCompareField-filterChips">
                    <agpr-filter-chips [id]="id">
                    </agpr-filter-chips>
                </div>
            </div>
            <agpr-message
                *ngIf="emptyParent"
                class="agpr-seriesPickerCompareField-emptyTagGroupMessage"
                [severity]="messageSeverityEnum.warning"
            >
                <span *ngIf="selectedCompareOption.value === SeriesCompareOptionsEnum.tagsWithinTagGroup; else themeError">
                    {{ 'Reports.emptyTagGroupWarning' | localize }}
                </span>
                <ng-template #themeError>
                    {{ 'Reports.emptyThemeWarning' | localize }}
                </ng-template>
            </agpr-message>
        </ng-template>
    </div>
</div>
